import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const UnlockedConversationIcon = (props: IconProps) => (
  <Icon w="54px" h="54px" viewBox="0 0 54 54" {...props}>
    <path d="M27 38.25c2.475 0 4.5-2.025 4.5-4.5s-2.025-4.5-4.5-4.5-4.5 2.025-4.5 4.5 2.025 4.5 4.5 4.5ZM40.5 18h-2.25v-4.5c0-6.21-5.04-11.25-11.25-11.25S15.75 7.29 15.75 13.5h4.275c0-3.8475 3.1275-6.975 6.975-6.975 3.8475 0 6.975 3.1275 6.975 6.975V18H13.5C11.025 18 9 20.025 9 22.5V45c0 2.475 2.025 4.5 4.5 4.5h27c2.475 0 4.5-2.025 4.5-4.5V22.5c0-2.475-2.025-4.5-4.5-4.5Zm0 27h-27V22.5h27V45Z" />
  </Icon>
);

export default memo(UnlockedConversationIcon);
